<template>
<div>
  <!-- slider Area Start-->
     <div class="slider-area ">
        <!-- Mobile Menu -->
        <div class="single-slider slider-height2 d-flex align-items-center" data-background="assets/hero/a.jpg">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12">
                        <div class="hero-cap text-center">
                            <h2>DESTINASI</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
     <!-- slider Area End-->
  <div class="favourite-place place-padding" style="margin-top: -5%">
    <div class="container">
      <!-- Section Tittle -->
      <div class="row">
        <div class="col-lg-12">
          <div class="section-tittle">
            <span>Destinasi Wisata</span>
            <h2>Destinasi Vaforit</h2>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top:-5%">
        <div class="col-md-6">
          <div class="form-group">
              <input @keyup="cari_data" v-model="cari_value" class="form-control valid" type="text" placeholder="Cari Destinasi"> 
          </div>

        </div>
        <div class="col-md-6">
          <div class="form-group" v-if="loadJenis">
            <select class="form-select valid w-100" data-live-search="true" v-model="m_jenisPariwisata" @change="cari_data()" style="padding-left:2%">
              <option value="" disabled>Pilih Jenis Destinasi --</option>
              <option value="">Semua Jenis Destinasi --</option>
              <option v-for="data in list_jenis_wisata" :key="data.id" :value="data.id">{{data.uraian}}</option>
            </select>
          </div>

   
          <!-- <h3>{{list_jenis_wisata}}</h3> -->

        </div>
          
      </div>
      <br>
      <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-6" v-for="(data, i) in list_data" :key="i">
          <div class="single-place mb-30">
            <div class="place-img">
             <img :src="$store.state.url.URL_APP+'uploads/'+data.fileThumb" alt="" height="250px">
            </div>
            <div class="place-cap">
              <div class="place-cap-top">
                <!-- <span><i class="fas fa-star"></i><span>8.0 Superb</span> </span> -->
                <h3><a href="javascript:void(0)" @click="routerToPlace('/wisataDetile?idx='+data.keyx)">{{data.uraian}}</a></h3>
                <p class="dolor" style="margin-top:-5%"> <span>Wisata Cagar Alam</span></p>
              </div>
              <div class="place-cap-bottom" style="margin-top:-12%">
                <ul>
                  <!-- <li><i class="far fa-clock"></i>3 Days</li> -->
                  <li><i class="fas fa-map-marker-alt"></i>{{data.nama_des_kel}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr>
      <div class="text-center">
        <button @click="btn_prev" type="button" class="genric-btn primary-border medium">Prev</button>
        &nbsp;
        <span style="color:#444444; font-size:11px; font-weight:bold">
          {{page_first}} - {{page_last}}
        </span>
        &nbsp;
        <button @click="btn_next" type="button" class="genric-btn primary-border medium">Next</button>
      </div>
      <hr>

    </div>
  </div>

    <!-- <script type="application/javascript" defer src="./assets/js/vendor/jquery-1.12.4.min.js"></script> -->


    <script type="application/javascript" defer src="./assets/js/plugins.js"></script>
    <script type="application/javascript" defer src="./assets/js/main.js"></script>
</div>
</template>

<script>


import FETCHING from  '../../library/fetching'


export default {
  data() {
    return {
      list_jenis_wisata : [],
      bidangPariwisata : 2,


      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
      page_limit : 9,

      m_jenisPariwisata : '',

      FETCHING : FETCHING,


      loadJenis : false
    }
  },

  methods: {
    getView: function() {
      fetch(this.$store.state.url.URL_WISATA_OBJEK + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          m_jenisPariwisata : this.m_jenisPariwisata,
          data_ke: this.page_first,
          cari_value: this.cari_value,
          page_limit : this.page_limit,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
            // console.log(res_data);
        });
    },


    btn_prev: function() {
      if (this.page_first > 1) {
          this.page_first--;
      } else {
          this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
          this.page_first == this.page_last;
      } else {
          this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.page_first = 1;
      this.getView();
    },

    fetcher : async function() {
      this.loadJenis = false
      this.list_jenis_wisata = await FETCHING.FETCH_POST(
        this.$store.state.url.URL_JENIS_WISATA + "list", 
        {bidangPariwisata : this.bidangPariwisata}
      )

      this.loadJenis = true

      // console.log(this.list_jenis_wisata)
    },
    routerToPlace(data){
            // console.log('telasooo')
            this.$router.push(data);
    },
  },

  mounted () {
    this.fetcher()
    this.getView();
  },


};
</script>

<style>
</style>